import { createContext, useContext } from "react";
import { api, fileUrl } from "../lib/api";

const ClientCtx = createContext({ client: api, fileUrl, quick: false, base: "", newPath: "/new", registerPath: "/pos" });

export const ClientProvider = ClientCtx.Provider;
export const useClient = () => useContext(ClientCtx);
